export const NO_REEL_OPTION_PARTICIPANT = {
    clubAbbreviation: null,
    playerName: null,
    jerseyNumber: null,
};
const key = (value) => value.trim().toLowerCase();
/** `<Player> - Total Points` names the player first; anything else names none. */
const playerNameFromMarket = (marketName) => {
    const name = marketName?.split(' - ')[0]?.trim() ?? '';
    return name !== '' && marketName?.includes(' - ') ? name : null;
};
/**
 * The club a Game Market pick is about: the side whose team name the outcome
 * is (Money Line, Spread), else the side whose team name the market starts
 * with (a team total), else none (a game total).
 */
const gameClub = (input) => {
    const { fixture } = input;
    const sides = [
        { name: key(fixture.homeTeam), abbreviation: fixture.homeClubAbbreviation },
        { name: key(fixture.awayTeam), abbreviation: fixture.awayClubAbbreviation },
    ].filter((side) => side.name !== '');
    const outcome = key(input.outcomeName);
    const market = key(input.marketName ?? '');
    const byOutcome = sides.find((side) => outcome === side.name || outcome.startsWith(`${side.name} `));
    if (byOutcome)
        return byOutcome.abbreviation;
    const byMarket = sides.find((side) => market.startsWith(`${side.name} `));
    return byMarket?.abbreviation ?? null;
};
export const resolveReelOptionParticipant = (input) => {
    const { marketParticipant } = input;
    if (marketParticipant) {
        return {
            clubAbbreviation: marketParticipant.clubAbbreviation,
            playerName: marketParticipant.name,
            jerseyNumber: marketParticipant.jerseyNumber,
        };
    }
    if (input.marketKind === 'player') {
        // A Player Market the sync could not place (NBA before its hub ids arrive): the
        // name is still the market's, and the club and number are the Operator's to set.
        return {
            clubAbbreviation: null,
            playerName: playerNameFromMarket(input.marketName),
            jerseyNumber: null,
        };
    }
    return { clubAbbreviation: gameClub(input), playerName: null, jerseyNumber: null };
};
/** The club the Game draws: the Operator's override when set, else the frozen one. */
export const effectiveClubAbbreviation = (record) => record.clubAbbreviationOverride ?? record.clubAbbreviation;
/** The number the Game draws on the jersey: the Operator's override when set, else the frozen one. */
export const effectiveJerseyNumber = (record) => record.jerseyNumberOverride ?? record.jerseyNumber;
//# sourceMappingURL=reel-option-participant.js.map